import { CALL_API } from '../middleware/api';
import * as qs from 'qs';

export const FETCH_ORDERS = "FETCH_ORDERS";
export const SUCCESS_FETCH_ORDERS = "SUCCESS_FETCH_ORDERS";
export const FAILURE_FETCH_ORDERS = "FAILURE_FETCH_ORDERS";
export const CLEAR_ORDERS = "CLEAR_ORDERS";

export const UPDATE_ORDER = "UPDATE_ORDER";
export const SUCCESS_UPDATE_ORDER = "SUCCESS_UPDATE_ORDER";
export const FAILURE_UPDATE_ORDER = "FAILURE_UPDATE_ORDER";
export const CLEAR_UPDATE_ORDER = "CLEAR_UPDATE_ORDER";

export const CREATE_ORDERS = "CREATE_ORDERS";
export const SUCCESS_CREATE_ORDERS = "SUCCESS_CREATE_ORDERS";
export const FAILURE_CREATE_ORDERS = "FAILURE_CREATE_ORDERS";

export const GET_AVAILABLE_PICKUP_DATE = "GET_AVAILABLE_PICKUP_DATE";
export const SUCCESS_AVAILABLE_PICKUP_DATE = "SUCCESS_AVAILABLE_PICKUP_DATE";
export const FAILURE_AVAILABLE_PICKUP_DATE = "FAILURE_AVAILABLE_PICKUP_DATE";

export const GET_AVAILABLE_OFFLOAD_DATE = "GET_AVAILABLE_OFFLOAD_DATE";
export const SUCCESS_AVAILABLE_OFFLOAD_DATE = "SUCCESS_AVAILABLE_OFFLOAD_DATE";
export const FAILURE_AVAILABLE_OFFLOAD_DATE = "FAILURE_AVAILABLE_OFFLOAD_DATE";
export const CLEAR_PICKUP_AND_OFFLOAD_DATE = "CLEAR_PICKUP_AND_OFFLOAD_DATE";

export const FETCH_MANUAL_COMPLETION = "FETCH_MANUAL_COMPLETION";
export const SUCCESS_MANUAL_COMPLETION = "SUCCESS_MANUAL_COMPLETION";
export const FAILURE_MANUAL_COMPLETION = "FAILURE_MANUAL_COMPLETION";

export const FETCH_DEBUG_ORDER_INFO = "FETCH_DEBUG_ORDER_INFO";
export const SUCCESS_DEBUG_ORDER_INFO = "SUCCESS_DEBUG_ORDER_INFO";
export const FAILURE_DEBUG_ORDER_INFO = "FAILURE_DEBUG_ORDER_INFO";

export function fetchOrders(path, filterData) {
    return {
        type: FETCH_ORDERS,
        [CALL_API]: {
            endpoint: `/api/orders${path}?${qs.stringify(filterData, { arrayFormat: 'repeat' })}`,
            method: 'get',
            types: [SUCCESS_FETCH_ORDERS, FAILURE_FETCH_ORDERS]
        },
    }
}

export function updateOrder(data) {
    const { Id } = data;
    return {
        type: UPDATE_ORDER,
        [CALL_API]: {
            endpoint: `/api/orders/update/${Id}`,
            method: 'post',
            types: [SUCCESS_UPDATE_ORDER, FAILURE_UPDATE_ORDER],
            data
        }
    }
}

export function createOrder(data) {
    return {
        type: CREATE_ORDERS,
        [CALL_API]: {
            endpoint: `/api/orders`,
            method: 'post',
            types: [SUCCESS_CREATE_ORDERS, FAILURE_CREATE_ORDERS],
            data
        }
    }
}

export function clearUpdateOrder() {
    return { type: CLEAR_UPDATE_ORDER }
}

export function clearOrders() {
    return { type: CLEAR_ORDERS };
}

export function getAvailablePickupDate() {
    return {
        type: GET_AVAILABLE_PICKUP_DATE,
        [CALL_API]: {
            endpoint: `/api/orders/available-pickup-date?timeZoneOffset=${new Date().getTimezoneOffset()}`,
            method: 'get',
            types: [SUCCESS_AVAILABLE_PICKUP_DATE, FAILURE_AVAILABLE_PICKUP_DATE],
        }
    }
}

export function getAvailableOffloadDate(data) {
    return {
        type: GET_AVAILABLE_OFFLOAD_DATE,
        [CALL_API]: {
            endpoint: `/api/orders/available-offload-date?timeZoneOffset=${new Date().getTimezoneOffset()}`,
            method: 'post',
            types: [SUCCESS_AVAILABLE_OFFLOAD_DATE, FAILURE_AVAILABLE_OFFLOAD_DATE],
            data
        }
    }
}

export function manualCompletion(data) {
    const reason = data.reason;
    return {
        type: FETCH_MANUAL_COMPLETION,
        [CALL_API]: {
            endpoint: `/api/orders/${data.id}/manual-completion`,
            method: 'post',
            types: [SUCCESS_MANUAL_COMPLETION, FAILURE_MANUAL_COMPLETION],
            data: reason
        }
    }
}

export function getOrderDebugInfo(id) {
    return {
        type: FETCH_DEBUG_ORDER_INFO,
        [CALL_API]: {
            endpoint: `/api/orders/debug-info/${id}`,
            method: 'get',
            types: [SUCCESS_DEBUG_ORDER_INFO, FAILURE_DEBUG_ORDER_INFO]
        }
    }
}

export function clearPickupAndOffloadDate() {
    return { type: CLEAR_PICKUP_AND_OFFLOAD_DATE };
}

export function getPendingOrdersCount() {
    return {
        type: 'GET_PENDING_ORDERS_COUNT_REQUEST',
        [CALL_API]: {
            endpoint: '/api/orders/pending',
            methos: 'get',
            types: ['GET_PENDING_ORDERS_COUNT_SUCCESS', 'GET_PENDING_ORDERS_COUNT_FAILURE']
        }
    }
}

export function clearPendingOrdersCount() {
    return { type: 'CLEAR_PENDING_ORDERS_COUNT' };
}


// WEBPACK FOOTER //
// ./src/actions/orders.js